import React from 'react';
import EntityRegistry from './app/entity/EntityRegistry';

export const EntityRegistryContext = React.createContext(new EntityRegistry());
